import MuiLink from '@mui/material/Link';

import IColumnDefinition from '../Table/IColumnDefinition';
import IRunFile from 'types/IRunFile';

const columns: IColumnDefinition<IRunFile>[] = [
  {
    header: 'Filename',
    key: 'filename',
    render: (file) => (
      <MuiLink href={file.url} target="_blank" download={file.filename}>
        {file.filename}
      </MuiLink>
    ),
    orderProperty: {
      key: 'filename',
      type: 'string',
      getVal: (file) => file.filename,
    },
  },
  {
    header: 'Tag',
    key: 'tag_name',
    orderProperty: {
      key: 'tag_name',
      type: 'string',
      getVal: (file) => file.tag_name,
    },
  },
  {
    header: 'Size',
    key: 'size',
    render: (file) => file.size ?? '',
  },
];

export default columns;
